import React from "react";
import PropTypes from "prop-types";
import { IoChevronBackOutline, IoChevronForwardOutline } from "react-icons/io5";

const Pagination = ({ pages, page, onPageChange }) => {
  const totalPagesToShow = 5;
  let startPage = Math.max(1, page - Math.floor(totalPagesToShow / 2));
  let endPage = Math.min(pages, startPage + totalPagesToShow - 1);

  if (endPage - startPage + 1 < totalPagesToShow) {
    startPage = Math.max(1, endPage - totalPagesToShow + 1);
  }

  const pageNumbers = [];
  for (let i = startPage; i <= endPage; i++) {
    pageNumbers.push(i);
  }

  if (startPage > 1) {
    pageNumbers.unshift("...");
  }

  if (endPage < pages) {
    pageNumbers.push("...");
  }

  return (
    <div className="pagination-container">
      <div className="entry-pagination">
        <div className="pagination">
          <nav>
            <ul>
              <li>
                <button
                  onClick={() => onPageChange(page - 1)}
                  disabled={page === 1}
                  className={`${page === 1 ? "disabled" : ""}`}
                >
                  <IoChevronBackOutline />
                </button>
              </li>
              {pageNumbers.map((p, index) => (
                <li key={index}>
                  {p === "..." ? (
                    <span className="ellipsis">{p}</span>
                  ) : (
                    <button
                      className={page === p ? "pageNo active" : "pageNo"}
                      onClick={() => onPageChange(p)}
                    >
                      {p}
                    </button>
                  )}
                </li>
              ))}
              <li>
                <button
                  onClick={() => onPageChange(page + 1)}
                  disabled={page === pages}
                  className={`${page === pages ? "disabled" : ""}`}
                >
                  <IoChevronForwardOutline />
                </button>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  );
};

Pagination.propTypes = {
  pages: PropTypes.number.isRequired,
  page: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
};

export default Pagination;